import { useLocation } from "react-router-dom";
import { getCurrentTaxDocumentsYear } from "./getCurrentTaxDocumentsYear";
import { TaxYear } from "../../../shared/constants/taxYear";

export const useCurrentTaxDocumentsYear = (): TaxYear => {
  const { pathname } = useLocation();

  return getCurrentTaxDocumentsYear(pathname);
};
